import { Chat } from "./Chat";
import { UseCase } from "./UseCase";

/**
 * Content moves up or down on the scale based on the following criteria:
 * - none: No content has been generated or provided.
 * - partial: Some content has been generated or provided, but it is incomplete or insufficient for the use case.
 * - sufficient: The content is complete and sufficient for the use case (e.g. for report generation)
 * - modified: The content was already processed or validated by an expert, but it has been modified
 * - expertValidated: The content has been validated by an expert and is considered accurate and reliable.
 * - processed: The content has been processed by the system (e.g. for report)
 */
export const ContentStatuses = ['none', 'partial', 'sufficient', 'modified', 'expertValidated', "processed"] as const;
export type ContentStatus = typeof ContentStatuses[number];

export function contentIsSufficientForReportGeneration(status: ContentStatus): boolean {
    return status === "sufficient" || status === "modified" || status === "expertValidated" || status === "processed";
}
export class UseCaseChat {
    id: string = "";

    contentStatus: ContentStatus = "none"

    useCase: UseCase = new UseCase();
    chat: Chat = new Chat();    

    constructor(init?: Partial<UseCaseChat>){
        Object.assign(this, init);  
    }

    get isSufficientForReportGeneration(): boolean {
        return contentIsSufficientForReportGeneration(this.contentStatus);
    }
}


